export default __webpack_public_path__ + "locales/sl/Payments.json?hash=a043dfc9469ecfba37b12d30f5bdd09e";